export function effectiveLoad(input) {
    const { bodyWeightKg, load, loadMode, purpose } = input;
    switch (loadMode) {
        case "per_hand":
            return load === null || purpose === "e1rm" ? load : load * 2;
        case "bodyweight_plus":
            return bodyWeightKg === null
                ? load
                : positiveOrNull(bodyWeightKg + (load ?? 0));
        case "assisted":
            return bodyWeightKg === null
                ? null
                : positiveOrNull(bodyWeightKg - (load ?? 0));
        default:
            return load;
    }
}
function positiveOrNull(value) {
    return value > 0 ? value : null;
}
/**
 * Everything but a warm-up counts (`D209`): a drop or a failure set is work.
 * Absent is a set from before the field, a working one.
 */
export function countsTowardTotals(set) {
    return set.kind !== "warmup";
}
export const LOADS_AS_LOGGED = {
    bodyWeightKg: null,
    loadModeOf: () => null,
};
/** Epley over the effective load, or `null` for a warm-up or no estimate. */
export function setE1rm(set, semantics = LOADS_AS_LOGGED) {
    if (!countsTowardTotals(set) || set.reps === null || set.reps < 1) {
        return null;
    }
    const load = effectiveLoad({
        bodyWeightKg: semantics.bodyWeightKg,
        load: set.load,
        loadMode: semantics.loadModeOf(set.exerciseId),
        purpose: "e1rm",
    });
    return load === null ? null : load * (1 + set.reps / 30);
}
/** `load × reps` for one set as volume counts it, `0` when it counts none. */
export function setVolume(set, semantics = LOADS_AS_LOGGED) {
    if (!countsTowardTotals(set) || set.reps === null) {
        return 0;
    }
    const load = effectiveLoad({
        bodyWeightKg: semantics.bodyWeightKg,
        load: set.load,
        loadMode: set.exerciseId === undefined
            ? null
            : semantics.loadModeOf(set.exerciseId),
        purpose: "volume",
    });
    if (load === null) {
        return 0;
    }
    const bothSides = set.exerciseId !== undefined &&
        (set.side ?? null) === null &&
        semantics.lateralityOf?.(set.exerciseId) === "unilateral";
    return load * set.reps * (bothSides ? 2 : 1);
}
//# sourceMappingURL=load-semantics.js.map